import { render, staticRenderFns } from "./interoperability-grid.vue?vue&type=template&id=5a2824a2&scoped=true&"
import script from "./interoperability-grid.ts?vue&type=script&lang=ts&"
export * from "./interoperability-grid.ts?vue&type=script&lang=ts&"
import style0 from "./interoperability-grid.scss?vue&type=style&index=0&id=5a2824a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2824a2",
  null
  
)

export default component.exports